export default __webpack_public_path__ + "static/media/female-icon.5e411f11.svg";